import './component';
import './preview';

Shopware.Service('cmsService').registerCmsBlock({
    name: 'manufacturer-block',
    category: 'commerce',
    label: 'manufacturer-pages.cms.blockLabel',
    component: 'sw-cms-block-manufacturer-block',
    previewComponent: 'sw-cms-preview-manufacturer-block',
    defaultConfig: {
        marginBottom: '0',
        marginTop: '0',
        marginLeft: '0',
        marginRight: '0',
        sizingMode: 'boxed'
    },
    slots: {
        manufacturerElement: 'manufacturer-element'
    }
});